var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    transform: "translate(0 0.5)",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12685_43073)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.5984 16.7996V15.3996C15.5984 14.657 15.3034 13.9448 14.7783 13.4197C14.2532 12.8946 13.541 12.5996 12.7984 12.5996H7.19844C6.45583 12.5996 5.74364 12.8946 5.21854 13.4197C4.69344 13.9448 4.39844 14.657 4.39844 15.3996V16.7996",
    stroke: "#212121",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0031 9.8002C11.5495 9.8002 12.8031 8.54659 12.8031 7.0002C12.8031 5.4538 11.5495 4.2002 10.0031 4.2002C8.45673 4.2002 7.20312 5.4538 7.20312 7.0002C7.20312 8.54659 8.45673 9.8002 10.0031 9.8002Z",
    stroke: "#212121",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12685_43073"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14.875,
    fill: "white",
    transform: "translate(3 3.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserBlack);
export default __webpack_public_path__ + "static/media/user_black.a24f768dfdb9969c53a8606f0ed2797e.svg";
export { ForwardRef as ReactComponent };